import { g as d } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as s, normalizeClass as o, createElementVNode as e } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const f = {
  name: "DtIconRefresh",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(r).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], p = ["clip-path"], h = ["id"];
function m(a, t, l, _, g, i) {
  return n(), s("svg", {
    "aria-label": l.ariaLabel,
    class: o([i.iconSizeClass, "d-icon d-icon--refresh"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Refresh",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    e("g", {
      "clip-path": `url(#${a.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      e("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M10.5.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h1.697l-.529-.476a4 4 0 1 0 1.335 3.424.5.5 0 0 1 .995.105A5 5 0 1 1 9.33 2.275l.004.004.665.598V1a.5.5 0 0 1 .5-.5Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, p),
    e("defs", null, [
      e("clipPath", {
        id: `${a.uniqueID}a`
      }, [...t[1] || (t[1] = [
        e("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, h)
    ])
  ], 10, c);
}
const S = /* @__PURE__ */ u(f, [["render", m]]);
export {
  S as default
};
//# sourceMappingURL=refresh.js.map
